// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","icon_route":"d5v5Wd","AniFadeIn":"BTmvUK","AniFadeOut":"qfiyYC","AniRotate":"_3nrKwj","AniPlaceholderFadeOut":"yjPz9J"};